import { h } from "preact";

export const QuantityMinus = () => (
  <svg
    width="8"
    height="2"
    viewBox="0 0 8 2"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 1.15202H0V1.52588e-05H8V1.15202Z" fill="currentColor" />
  </svg>
);

export const QuantityPlus = () => (
  <svg
    width="9"
    height="9"
    viewBox="0 0 9 9"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.000144601 3.64793H3.64814V-7.43866e-05H4.70414V3.64793H8.35215V4.70393H4.70414V8.35193H3.64814V4.70393H0.000144601V3.64793Z"
      fill="#353740"
    />
  </svg>
);

export const QuantityMinusRound = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.70605 12H17.2943"
      stroke="currentColor"
      stroke-linecap="square"
    />
  </svg>
);

export const QuantityPlusRound = () => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.70605 13H18.2943"
      stroke="currentColor"
      stroke-linecap="square"
    />
    <path
      d="M13 7.70581V18.294"
      stroke="currentColor"
      stroke-linecap="square"
    />
  </svg>
);

export const CaretDown = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 6L7.97657 10L4 6Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 6L8.02343 10L12 6Z"
      fill="currentColor"
    />
    <path
      d="M4 6L7.97657 10M12 6L8.02343 10"
      stroke="currentColor"
      strokeLinecap="square"
    />
  </svg>
);

export const ArrowUpRight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.5 11.5L11.5 4.5M11.5 4.5H5.5M11.5 4.5V10.5"
      stroke="currentColor"
      strokeLinecap="square"
    />
  </svg>
);

export const ArrowRight = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5730_20249)">
      <path
        d="M3 9.6001H16.2"
        stroke="currentColor"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.8008 4.2002L16.2008 9.60019L10.8008 15.0002"
        stroke="currentColor"
        stroke-width="0.8"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_5730_20249">
        <rect width="19.2" height="19.2" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const Check = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.5 8.5L6.5 11.5L12.5 4.5"
      stroke="currentColor"
      strokeLinecap="square"
    />
  </svg>
);

export const SwatchCheck = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.83008 13.0427L10.2642 17.5844L19.5 8.12061"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
  </svg>
);

export const CaretLeft = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.333 1.66675L4.6663 8.29436M11.333 15.0001L4.6663 8.37247"
      stroke="currentColor"
      stroke-linecap="square"
    />
  </svg>
);

export const Close = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.5 2.5L13.5 13.5M13.5 2.5L2.5 13.5" stroke="currentColor" />
  </svg>
);

export const Plus = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 2.5V13.5M2.5 8H13.5" stroke="currentColor" />
  </svg>
);

export const Minus = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M2.5 8H13.5" stroke="currentColor" />
  </svg>
);

export const MonogramMark = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 342 332"
    fill="currentColor"
    preserveAspectRatio="xMidYMid meet"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M91.5465653,161.453973 L52.3875653,161.453973 L52.3745653,80.972973 L52.3855653,58.606973 L52.4965653,55.334973 C54.5105653,52.911973 56.7005653,50.535973 59.0105653,48.265973 C63.5315653,43.828973 68.7635653,39.637973 75.9745653,34.679973 L76.0795653,34.606973 C79.6255653,32.169973 83.2925653,29.649973 87.1435653,27.623973 C88.5045653,26.906973 89.9365653,26.229973 91.3935653,25.583973 L91.2955653,77.861973 L91.5465653,161.453973 Z M39.4135653,274.153973 L51.4835653,286.268973 L52.9945653,286.334973 L52.4815653,268.363973 L52.4035653,262.588973 L52.3885653,169.645973 L91.5705653,169.577973 L91.9645653,300.463973 L87.3655653,310.115973 L97.3845653,316.270973 L99.3035653,316.293973 L99.2855653,300.548973 L99.3995653,78.019973 L99.3215653,12.410973 C99.3215653,12.410973 89.9055653,16.145973 86.1665653,18.137973 C80.9435653,20.915973 76.0035653,24.395973 71.6445653,27.466973 C65.6945653,31.659973 58.7625653,36.758973 52.4645653,42.788973 C50.6085653,44.566973 48.8095653,46.451973 47.0705653,48.274973 C45.8555653,49.548973 44.6405653,50.821973 43.3985653,52.069973 C42.3395653,53.133973 41.2755653,54.192973 40.2115653,55.244973 L39.8665653,55.585973 L44.0895653,66.894973 L44.2105653,262.141973 L41.8365653,267.932973 L39.4135653,274.153973 Z" />
    <path d="M0.13096527,162.010073 C0.15496527,162.871073 0.17296527,163.734073 0.19096527,164.596073 C0.21596527,165.827073 0.24096527,167.058073 0.28696527,168.284073 C0.37296527,170.731073 0.49796527,173.302073 0.65896527,175.925073 C0.86996527,179.376073 1.06796527,182.013073 1.30096527,184.475073 C1.60096527,187.666073 1.99396527,190.824073 2.46896527,193.860073 C2.97796527,197.169073 3.60696527,200.552073 4.33896527,203.916073 L4.46696527,204.507073 L6.37796527,204.507073 L6.39096527,203.770073 C6.44996527,200.440073 6.60996527,197.049073 6.86696527,193.690073 L6.94396527,192.696073 C7.15596527,189.940073 7.37496527,187.091073 7.83596527,184.337073 L7.91296527,183.873073 C8.36196527,181.174073 8.82596527,178.383073 10.0139653,175.952073 C11.4949653,172.932073 13.5599653,170.301073 16.1509653,168.132073 L16.6839653,167.686073 L16.2799653,167.121073 C14.9329653,165.238073 13.7459653,163.216073 12.7499653,161.112073 C11.6269653,158.730073 10.6789653,155.981073 9.76796527,152.462073 C8.93996527,149.225073 8.43996527,145.910073 7.95696527,142.702073 C7.41396527,139.200073 6.93496527,136.043073 6.57096527,132.877073 C6.35796527,130.990073 6.18596527,129.285073 6.04696527,127.664073 L5.98796527,126.978073 L4.47496527,126.978073 L4.31996527,127.524073 C3.80896527,129.331073 3.36196527,131.106073 2.99196527,132.802073 C2.40296527,135.510073 2.00196527,138.283073 1.61196527,140.967073 L1.33596527,142.857073 C1.24396527,143.482073 1.14796527,144.107073 1.05196527,144.731073 C0.66196527,147.270073 0.25796527,149.896073 0.10196527,152.523073 C-0.0730347299,155.308073 0.0129652701,158.124073 0.0959652701,160.847073 L0.13096527,162.010073 Z" />
    <path d="M196.671565,140.237673 L133.135565,177.088673 L132.921565,16.6886727 L132.921565,12.9416727 C136.121565,12.1286727 139.421565,11.4126727 142.742565,10.8106727 C148.302565,9.80067266 152.955565,9.19467266 157.386565,8.90467266 C162.270565,8.58467266 167.512565,8.61267266 173.412565,8.99467266 C179.304565,9.37767266 184.391565,10.0096727 188.964565,10.9276727 C191.488565,11.4336727 194.060565,12.0546727 196.617565,12.7756727 L196.499565,66.8526727 L196.671565,140.237673 Z M133.147565,186.314673 L164.524565,167.870673 L196.831565,196.995673 L196.391565,251.014673 L196.618565,300.168673 L196.613565,318.829673 C194.882565,319.422673 193.108565,319.942673 191.329565,320.377673 C187.553565,321.299673 183.581565,321.764673 179.837565,322.162673 C172.687565,322.918673 164.974565,322.999673 156.255565,322.410673 C152.043565,322.126673 147.557565,321.786673 143.095565,321.048673 C139.621565,320.471673 136.139565,319.716673 132.736565,318.801673 L133.041565,314.506673 L133.293565,296.059673 L133.147565,186.314673 Z M154.652565,330.553673 C158.210565,330.844673 161.838565,330.990673 165.519565,330.990673 C170.550565,330.990673 175.680565,330.718673 180.861565,330.174673 C186.093565,329.626673 190.684565,328.952673 194.898565,328.116673 C199.236565,327.259673 203.586565,326.186673 207.827565,324.925673 L208.636565,324.685673 L204.639565,315.424673 L204.734565,251.116673 L204.993565,193.112673 L172.313565,163.291673 L205.454565,143.804673 L205.226565,16.7406727 L208.335565,7.65667266 L207.589565,7.43267266 C202.827565,5.99967266 197.959565,4.80067266 193.121565,3.86867266 C187.597565,2.80967266 181.570565,2.04467266 174.695565,1.52867266 C169.448565,1.13967266 163.230565,0.790672656 156.904565,1.15067266 C151.550565,1.45867266 146.183565,2.33867266 140.993565,3.18967266 L139.458565,3.44067266 C133.521565,4.40467266 127.482565,5.58867266 121.508565,6.95867266 L120.572565,7.17367266 L125.368565,16.6036727 L124.344565,295.896673 L124.754565,315.312673 L120.321565,324.066673 L121.192565,324.317673 C127.090565,326.018673 133.121565,327.422673 139.117565,328.489673 C144.602565,329.470673 149.683565,330.145673 154.652565,330.553673 L154.652565,330.553673 Z" />
    <path d="M234.03924,44.7801812 L234.374231,96.7466556 L234.803937,290.74931 L234.725174,316.072037 L235.82187,316.606427 C239.357222,315.266463 242.869642,313.734079 246.264417,312.052145 C251.03106,309.686271 255.799696,306.885707 260.43972,303.72722 C265.896285,300.010415 270.878279,295.822031 274.609042,292.587773 C280.931,287.109274 285.869126,282.267857 290.151228,277.350668 C291.216021,276.123364 292.157186,274.998752 293.028561,273.914019 L293.264849,273.618908 L290.906952,264.726692 L290.645738,214.063292 L281.870171,214.171965 L282.081534,264.638956 L282.013738,270.808373 L281.927997,274.325779 C277.976898,278.224037 273.81942,282.010632 269.568225,285.582872 C264.748741,289.631677 260.646099,292.813094 256.656117,295.593719 C253.785762,297.595689 250.708033,299.695364 247.403985,301.432133 C245.972297,302.185863 244.487768,302.866812 242.990279,303.511869 L243.056081,290.955689 L243.44491,97.0846376 L243.44491,34.0106196 C246.282363,35.2668358 249.082928,36.6775866 251.790771,38.2358929 C256.360009,40.8689619 260.520477,43.9666316 263.634099,46.3703914 C266.812525,48.823004 270.09763,51.5477968 273.974952,54.9425715 C276.633943,57.2675685 279.317858,59.7231721 281.95691,62.2445776 L282.33178,66.0212022 L282.146339,73.9373583 L281.826303,125.469142 L290.066483,125.37343 L290.386519,74.0958809 L293.518087,63.6523373 L293.328657,63.3622112 C292.057486,61.4130821 290.642747,59.4689379 289.124321,57.5826196 C286.386567,54.1868478 283.279925,51.1170941 280.330807,48.3055625 C275.735648,43.9237607 271.700801,40.5409499 267.633054,37.6576346 C263.916249,35.0275565 259.904333,32.7444334 256.025018,30.5370821 L254.093834,29.4363974 C247.819732,25.8402292 241.345234,22.3946076 234.848801,19.1942472 L234.033258,20.5222472 L234.03924,44.7801812 Z" />
    <path d="M340.823102,145.048967 C340.72739,144.429832 340.632675,143.810696 340.540952,143.190564 L340.269768,141.340138 C339.881937,138.654228 339.47915,135.876594 338.889925,133.166757 C338.518045,131.46588 338.086345,129.745063 337.565913,127.905603 L337.412375,127.360246 L335.902922,127.360246 L335.845096,128.044186 C335.70751,129.650348 335.536027,131.350228 335.320675,133.240534 C334.959762,136.39603 334.482201,139.544546 333.940831,143.040018 C333.458285,146.235393 332.960783,149.539441 332.134273,152.765723 C331.227006,156.272162 330.281852,159.012907 329.162225,161.390745 C328.17121,163.487429 326.986777,165.50236 325.641828,167.382696 L325.239042,167.946 L325.770441,168.39066 C328.35366,170.553147 330.412459,173.176246 331.888015,176.18618 C333.074441,178.611874 333.536051,181.396486 333.984699,184.088378 L334.061468,184.547994 C334.520087,187.288739 334.737432,190.125195 334.948795,192.868931 L335.026561,193.87191 C335.282789,197.214841 335.443306,200.595657 335.501132,203.921639 L335.514093,204.656426 L337.419354,204.656426 L337.54697,204.067201 C338.274777,200.725267 338.901888,197.352426 339.412351,194.043393 C339.887919,191.001555 340.278741,187.853039 340.575846,184.685579 C340.872952,181.555009 341.074345,178.485255 341.216916,176.161255 C341.376435,173.544138 341.50106,170.980859 341.586801,168.544198 C341.632663,167.312907 341.658585,166.07663 341.682513,164.841351 C341.700459,163.988919 341.717408,163.137483 341.742333,162.287045 L341.776231,161.158444 C341.859979,158.432654 341.94572,155.615141 341.771246,152.831525 C341.615714,150.206432 341.212928,147.58433 340.823102,145.048967" />
  </svg>
);

export const CaretRight = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66699 1.66675L11.3337 8.29436L4.66699 1.66675Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66699 15.0001L11.3337 8.37247L4.66699 15.0001Z"
      fill="currentColor"
    />
    <path
      d="M4.66699 1.66675L11.3337 8.29436M4.66699 15.0001L11.3337 8.37247"
      stroke="currentColor"
      strokeLinecap="square"
    />
  </svg>
);

export const Ruler = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.5307 2.46994L2.47003 15.5306C2.17713 15.8235 2.17713 16.2984 2.47003 16.5913L7.40939 21.5307C7.70228 21.8236 8.17716 21.8236 8.47005 21.5307L21.5308 8.46996C21.8236 8.17707 21.8236 7.7022 21.5308 7.4093L16.5914 2.46994C16.2985 2.17705 15.8236 2.17705 15.5307 2.46994Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6L15 9M9 9L12 12M6 12L9 15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
